/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-useless-escape
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import ReactSpreadsheet from "react-spreadsheet";
import * as ReactDOM from 'react-dom';
import '../../../assets/styles/styles.scss'
import { APIEndpoint } from "../../../utils/axios";
import { FaRegCheckSquare, FaSave } from "react-icons/fa";
import { BiSolidSelectMultiple } from "react-icons/bi";
import moment from 'moment';
import { AlertModal, LoaderPop } from "../../../common";
import { RiDeleteBin6Line } from "react-icons/ri";
import { formatDateByTimezone, validateCellAndGetData } from "../../../utils/commonFunctions";
import { DEFAULT_SHEET_ROWS_PLIFERAGE } from "../../../utils/configs";
import { useTranslation } from "react-i18next";
import close from "../../../images/icons/Icon2.png"

const reasonTypes = [
    { id: 'lost', label: 'Lost' },
    { id: 'damage', label: 'Damage' },
    { id: 'complimentary', label: 'Complimentary' },
    { id: 'suppliedToStaff', label: 'Supplied To Staff' },
    { id: 'expired', label: 'Expired' }
];

const iIndexes = {
    ITEM_CODE: 0,
    ITEM_NAME: 1,
    ITEM_UNIT: 2,
    TOTAL_OFFLOADED: 3,
    TOTAL_UNLOADED: 4,
    ACTUAL_OFFLOAD: 5,
    DAMAGE: 6,
    WASTAGE: 7,
    EXPIRED: 8,
    LOST: 9,
    BACK_TO_WAREHOUSE: 10,
    REMARKS: 11
};

const sheetLabels = ['Item Code', 'Item Name', 'Unit', 'Offloaded', 'Unloaded', 'Actual Offload', 'Damage', 'Wastage', 'Expired', 'Lost', 'Back To Warehouse', 'Remarks'];

const defaultCellFieldData = {
    id: 'id',
    value: '',
    defaultValue: '',
    className: 'cellClass',
    width: '200px',
    readOnly: false,
    type: 'string',
    required: true,
    showPopup: false
};

const createEmptySheetRows = (addtionalRows = 0, noOfRows = DEFAULT_SHEET_ROWS_PLIFERAGE) => {
    const rows = [];
    if (addtionalRows > 0) {
        let i = 0;
        while (i < 10) {
            rows.push([
                { ...defaultCellFieldData, id: 'itemCode', className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ITEM_CODE, showPopup: true },
                { ...defaultCellFieldData, id: 'itemName', className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ITEM_NAME, showPopup: true },
                { ...defaultCellFieldData, id: 'unit', className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ITEM_UNIT, width: '400px', required: true, readOnly: true, showPopup: true },
                { ...defaultCellFieldData, type: 'number', id: 'totalOffloaded', showPopup: false, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL_OFFLOADED, readOnly: true, required: false },
                { ...defaultCellFieldData, type: 'number', id: 'totalUnloaded', showPopup: false, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL_UNLOADED, readOnly: true, required: false },
                { ...defaultCellFieldData, id: 'actualOffload', className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.ACTUAL_OFFLOAD, width: '400px', required: true, readOnly: false, showPopup: true },
                { ...defaultCellFieldData, type: 'number', id: 'damage', showPopup: true, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.DAMAGE, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'wastage', showPopup: true, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.WASTAGE, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'expired', showPopup: true, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.EXPIRED, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'lost', showPopup: true, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.LOST, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'backToWarehouse', showPopup: true, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.BACK_TO_WAREHOUSE, readOnly: false, required: true },
                { ...defaultCellFieldData, id: 'remarks', required: false, readOnly: false, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.REMARKS },
            ]);
            i++;
            addtionalRows++;
        }
    } else {
        for (var i = 0; i < noOfRows; i++) {
            rows.push([
                { ...defaultCellFieldData, id: 'itemCode', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_CODE, showPopup: true },
                { ...defaultCellFieldData, id: 'itemName', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_NAME, showPopup: true },
                { ...defaultCellFieldData, id: 'unit', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_UNIT, width: '400px', required: true, readOnly: true, showPopup: true },
                { ...defaultCellFieldData, type: 'number', id: 'totalOffloaded', showPopup: false, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL_OFFLOADED, readOnly: true, required: false },
                { ...defaultCellFieldData, type: 'number', id: 'totalUnloaded', showPopup: false, className: 'cellClass cellClass_' + addtionalRows + '_' + iIndexes.TOTAL_UNLOADED, readOnly: true, required: false },
                { ...defaultCellFieldData, id: 'actualOffload', className: 'cellClass cellClass_' + i + '_' + iIndexes.ACTUAL_OFFLOAD, width: '400px', required: true, readOnly: false, showPopup: true },
                { ...defaultCellFieldData, type: 'number', id: 'damage', showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.DAMAGE, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'wastage', showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.WASTAGE, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'expired', showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.EXPIRED, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'lost', showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.LOST, readOnly: false, required: true },
                { ...defaultCellFieldData, type: 'number', id: 'backToWarehouse', showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.BACK_TO_WAREHOUSE, readOnly: false, required: true },
                { ...defaultCellFieldData, id: 'remarks', required: false, readOnly: false, className: 'cellClass cellClass_' + i + '_' + iIndexes.REMARKS },
            ]);
        }
    }
    return rows;
}

const initialData = createEmptySheetRows(DEFAULT_SHEET_ROWS_PLIFERAGE);

export const ReconciliationsCreate = (props) => {
    const urlParams = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const initLoadFilters = useRef(true);

    const [warehouseItemsFull, setWarehouseItemsFull] = useState([]);
    const [warehouseItemsFiltered, setWarehouseItemsFiltered] = useState([]);
    const [reconciliationMaster, setReconciliationMaster] = useState([]);
    const [editTransferDetails, setEditTransferDetails] = useState({});
    const [state, setState] = useState({ isInvalidAccess: false, message: '', isEditForm: false });
    const [sheetData, setSheetData] = useState(initialData);
    const [storeArray, setStoreArray] = useState([]);
    const [warehouseArr, setWareHouseArr] = useState([]);
    const [itemMasterAll, setItemMasterAll] = useState([]);
    const [spreadsheetErrors, setSpreadsheetErrors] = useState([]);
    const [updatedItemsWithDutyFree, setUpdatedItemsDutyFree] = useState([]);
    const [filterItemsType, setFilterItemType] = useState({ all: { checked: true, count: 0 }, dutyPaid: { checked: false, count: 0 }, dutyFree: { checked: false, count: 0 } });
    const [errorDetails, setErrorDetails] = useState([]);
    const modelStyle = { maxWidth: '50%', margin: 'auto 10% 100% 10%' };
    const [activeCell, setActiveCell] = useState({});
    const [loading, setLoading] = useState(false);
    const [selectedCellsArr, setSelectedCellsArr] = useState([]);
    const [reconDetails, setReconDetails] = useState({ warehouse: "", store: "", date: "" });
    const [count, setCount] = useState(1);
    const [copiedValues, setCopiedValues] = useState([]);
    const [isCopied, setIsCopied] = useState(false);
const dragStartCellRef = useRef(null);
const selectedCellsRef = useRef([]);
const warehouseItemsFullRef = useRef([]);
useEffect(() => { warehouseItemsFullRef.current = warehouseItemsFull; }, [warehouseItemsFull]);
const activeCellRef = useRef({});
useEffect(() => { activeCellRef.current = activeCell; }, [activeCell]);
    const targetEltCodes = document.getElementsByClassName("cellSelectionBlockItemCodes")[0];
    const targetEltNames = document.getElementsByClassName("cellSelectionBlockItemNames")[0];
    const targetEltReasonTypes = document.getElementsByClassName("cellSelectionBlockReasonTypes")[0];
    const prevOptionsRef = useRef(null);

    useEffect(() => {
        const handleKeyboard = (e) => {
            const tag = document.activeElement?.tagName?.toLowerCase();
            const isTyping = tag === 'input' || tag === 'textarea';

            if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
                if (selectedCellsArr.length > 0) {
                    const rows = [...new Set(selectedCellsArr.map(c => c.row))].sort((a, b) => a - b);
                    const cols = [...new Set(selectedCellsArr.map(c => c.column))].sort((a, b) => a - b);

                    const copied = rows.map(r =>
                        cols.map(c => sheetData[r]?.[c]?.value ?? '')
                    );
                    setCopiedValues(copied);
                    setIsCopied(true);
                    setTimeout(() => setIsCopied(false), 1500);

                    const text = copied.map(row => row.join('\t')).join('\n');
                    navigator.clipboard.writeText(text).catch(() => { });
                }
            }

            if ((e.ctrlKey || e.metaKey) && e.key === 'v' && !isTyping) {
                navigator.clipboard.readText().then(text => {
                    if (!text) return;

                    const targetRow = activeCell && Object.keys(activeCell).length > 0
                        ? activeCell.row
                        : (selectedCellsArr.length > 0
                            ? Math.min(...selectedCellsArr.map(c => c.row))
                            : 0);
                    const targetCol = activeCell && Object.keys(activeCell).length > 0
                        ? activeCell.column
                        : (selectedCellsArr.length > 0
                            ? Math.min(...selectedCellsArr.map(c => c.column))
                            : 0);

                    const pasteRows = text.split('\n').map(r => r.split('\t'));
                    let jsonData = JSON.stringify(sheetData);
                    let updatedData = JSON.parse(jsonData);

                    pasteRows.forEach((rowVals, rOffset) => {
                        rowVals.forEach((val, cOffset) => {
                            const destRow = targetRow + rOffset;
                            const destCol = targetCol + cOffset;
                            if (
                                updatedData[destRow]?.[destCol] &&
                                !updatedData[destRow][destCol].readOnly
                            ) {
                                updatedData[destRow][destCol] = {
                                    ...updatedData[destRow][destCol],
                                    value: val.trim()
                                };
                            }
                        });
                    });

                    setSheetData([...updatedData]);
                }).catch(() => { });
            }
        };

        document.addEventListener('keydown', handleKeyboard);
        return () => document.removeEventListener('keydown', handleKeyboard);
    }, [selectedCellsArr, activeCell, sheetData]);


    useEffect(() => {
        if (selectedCellsArr.length > 1) {
            hidePopupList();
            setSpreadsheetErrors([]);
        }
    }, [selectedCellsArr]);

    useEffect(() => {
        if (itemMasterAll.length && initLoadFilters.current && editTransferDetails?.items?.length) {
            const itemMap = new Map(itemMasterAll.map(item => [item.itemId, item]));
            const updatedItemsWithDutyFree = editTransferDetails?.items?.map(item => {
                const sourceItem = itemMap.get(item.itemId);
                return { ...item, dutyFree: sourceItem ? sourceItem.dutyFree : null };
            });
            if (updatedItemsWithDutyFree.length && filterItemsType.all.checked) {
                setFilterItemType(prev => ({
                    ...prev,
                    all: { ...prev.all, count: updatedItemsWithDutyFree.length },
                    dutyFree: { ...prev.dutyFree, count: updatedItemsWithDutyFree.filter(item => item.dutyFree).length },
                    dutyPaid: { ...prev.dutyPaid, count: updatedItemsWithDutyFree.filter(item => !item.dutyFree).length }
                }));
                setUpdatedItemsDutyFree(updatedItemsWithDutyFree);
                setReconciliationMaster(sheetData);
                initLoadFilters.current = false;
                setLoading(false);
            }
        }
    }, [editTransferDetails, itemMasterAll, urlParams]);

    const filteredItems = useMemo(() => {
        return filterItemsType.dutyFree.checked
            ? updatedItemsWithDutyFree.filter(item => item.dutyFree)
            : filterItemsType.dutyPaid.checked
                ? updatedItemsWithDutyFree.filter(item => !item.dutyFree)
                : updatedItemsWithDutyFree;
    }, [filterItemsType, updatedItemsWithDutyFree]);

    const options = useMemo(() => {
        return filteredItems.map((item, i) => [
            { id: 'itemCode', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_CODE, value: item.itemCode, showPopup: true },
            { id: 'itemName', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_NAME, value: item.itemName, showPopup: true },
            { id: 'unit', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_UNIT, width: '400px', value: item.unit, required: true, readOnly: true, showPopup: true },
            { ...defaultCellFieldData, type: 'number', id: 'totalOffloaded', value: item.totalOffloaded ?? null, showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL_OFFLOADED, readOnly: true, required: true },
            { ...defaultCellFieldData, type: 'number', id: 'totalUnloaded', value: item.totalUnloaded ?? null, showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL_UNLOADED, readOnly: true, required: true },
            { id: 'actualOffload', className: 'cellClass cellClass_' + i + '_' + iIndexes.ACTUAL_OFFLOAD, width: '400px', value: item.actualOffload, required: true, readOnly: false, showPopup: true },
            { type: 'number', id: 'damage', showPopup: true, value: item.damage, className: 'cellClass cellClass_' + i + '_' + iIndexes.DAMAGE, readOnly: false, required: true },
            { type: 'number', id: 'wastage', showPopup: true, value: item.wastage, className: 'cellClass cellClass_' + i + '_' + iIndexes.WASTAGE, readOnly: false, required: true },
            { type: 'number', id: 'expired', showPopup: true, value: item.expired, className: 'cellClass cellClass_' + i + '_' + iIndexes.EXPIRED, readOnly: false, required: true },
            { type: 'number', id: 'lost', showPopup: true, value: item.lost, className: 'cellClass cellClass_' + i + '_' + iIndexes.LOST, readOnly: false, required: true },
            { type: 'number', id: 'backToWarehouse', value: item.backToWarehouse, showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.BACK_TO_WAREHOUSE, readOnly: false, required: true },
            { id: 'remarks', required: false, readOnly: false, value: item.remarks, className: 'cellClass cellClass_' + i + '_' + iIndexes.REMARKS },
        ]);
    }, [filteredItems, iIndexes]);

    useEffect(() => {
        if (!initLoadFilters.current && updatedItemsWithDutyFree.length) {
            if (options.length && JSON.stringify(prevOptionsRef.current) !== JSON.stringify(options)) {
                prevOptionsRef.current = options;
                setEditTransferItemsToSheet(filteredItems, options);
                const newRows = createEmptySheetRows(null, 10);
                setSheetData([...options, ...newRows.slice(options.length)]);
            }
        }
    }, [options, filteredItems]);

    useEffect(() => {
        let timeout = setTimeout(() => {
            const errorCells = document.querySelectorAll(".errorCellData");
            if (errorCells.length === 0) return;
            errorCells.forEach((cell, i) => {
                const rowIndex = [...cell.classList][3].split("_")[1];
                const error = errorDetails.find((err) => err.row === rowIndex);
                if (!cell.querySelector(".sheetErrDiv") && error) {
                    const errorDiv = document.createElement("div");
                    errorDiv.classList.add("sheetErrDiv");
                    errorDiv.textContent = error?.message;
                    cell.appendChild(errorDiv);
                }
            });
        }, 100);
        return () => clearTimeout(timeout);
    }, [errorDetails, sheetData, activeCell]);

    useEffect(() => {
        let timeout = setTimeout(() => {
            const errorCells = document.querySelectorAll(".errorCellData");
            if (errorCells.length === 0) return;
            errorCells.forEach((cell, i) => {
                cell.scrollIntoView({ behavior: "smooth" });
            });
        }, 1000);
        return () => clearTimeout(timeout);
    }, [errorDetails]);

    useEffect(() => {
        const { ftDt, opDt, sId, wId, rId, params } = urlParams;
        const body = {
            operationDate: formatDateByTimezone(opDt ? new Date(opDt) : new Date(), false),
            flightDate: formatDateByTimezone(ftDt ? new Date(ftDt) : new Date(), false),
            warehouseId: Number(wId),
            storeId: Number(sId),
            reconId: params === 'create' ? null : rId,
        };
        if ((urlParams.hasOwnProperty('sId') || urlParams.hasOwnProperty('wId')) && (params === 'create')) {
            fetchStores();
            fetchWarehouse();
            setState(prevState => ({ ...prevState, isEditForm: false }));
            setReconDetails(_ => ({
                ..._,
                date: moment(formatDateByTimezone(ftDt ?? new Date(), false)).format('DD-MM-YYYY')
            }));
        } else {
            setState(prevState => ({ ...prevState, isEditForm: true }));
        }
        getItemMasterAll();
        getWarehouseItems(body);
    }, [urlParams]);

    useEffect(() => {
        if (Object.keys(editTransferDetails).length > 0 && editTransferDetails?.items.length) {
            const options = [];
            editTransferDetails?.items.forEach((item, i) => {
                options.push([
                    { id: 'itemCode', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_CODE, value: item.itemCode, showPopup: true },
                    { id: 'itemName', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_NAME, value: item.itemName, showPopup: true },
                    { id: 'unit', className: 'cellClass cellClass_' + i + '_' + iIndexes.ITEM_UNIT, width: '400px', value: item.unit, required: true, readOnly: true, showPopup: true },
                    { id: 'actualOffload', className: 'cellClass cellClass_' + i + '_' + iIndexes.ACTUAL_OFFLOAD, width: '400px', value: item.actualOffload, required: true, readOnly: false, showPopup: true },
                    { type: 'number', id: 'damage', showPopup: true, value: item.damage, className: 'cellClass cellClass_' + i + '_' + iIndexes.DAMAGE, readOnly: false, required: true },
                    { type: 'number', id: 'wastage', showPopup: true, value: item.wastage, className: 'cellClass cellClass_' + i + '_' + iIndexes.WASTAGE, readOnly: false, required: true },
                    { type: 'number', id: 'expired', showPopup: true, value: item.expired, className: 'cellClass cellClass_' + i + '_' + iIndexes.EXPIRED, readOnly: false, required: true },
                    { type: 'number', id: 'lost', showPopup: true, value: item.lost, className: 'cellClass cellClass_' + i + '_' + iIndexes.LOST, readOnly: false, required: true },
                    { type: 'number', id: 'backToWarehouse', value: item.backToWarehouse, showPopup: true, className: 'cellClass cellClass_' + i + '_' + iIndexes.BACK_TO_WAREHOUSE, readOnly: false, required: true },
                    { type: 'number', id: 'totalOffloaded', value: item.totalOffloaded, showPopup: false, className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL_OFFLOADED, readOnly: true, required: false },
                    { type: 'number', id: 'totalUnloaded', showPopup: false, className: 'cellClass cellClass_' + i + '_' + iIndexes.TOTAL_UNLOADED, readOnly: true, required: false },
                    { id: 'remarks', required: false, readOnly: false, value: item.remarks, className: 'cellClass cellClass_' + i + '_' + iIndexes.REMARKS },
                ]);
            });

            if (options) {
                setEditTransferItemsToSheet(editTransferDetails, options);
                const newRows = createEmptySheetRows(null, 10);
                setSheetData([...options, ...newRows.slice(options.length)]);
            }
        }
    }, [editTransferDetails]);

    useEffect(() => {
        if (errorDetails.length) {
            const updatedSheetData = sheetData.map((row, rowIndex) => {
                return row.map((cell, colIndex) => {
                    const error = errorDetails.find(err => parseInt(err.row) === rowIndex);
                    if (error && Object.values(cell).includes(error.field)) {
                        return { ...cell, className: `errorCellData cellClass cellClass_${rowIndex}_${colIndex}` };
                    }
                    return { ...cell };
                });
            });
            setSheetData(updatedSheetData);
        }
    }, [errorDetails]);

    useEffect(() => {
        if (storeArray && warehouseArr && (urlParams.hasOwnProperty('sId') || urlParams.hasOwnProperty('wId'))) {
            let storeSelObj = storeArray.find((i) => Number(urlParams.sId) === i.id);
            let warehouseObj = warehouseArr?.find((i) => Number(urlParams.wId) === i?.id);
            if (storeSelObj) setReconDetails((_) => ({ ..._, store: storeSelObj?.value }));
            if (warehouseObj) setReconDetails((_) => ({ ..._, warehouse: warehouseObj?.warehouseCode }));
        }
    }, [storeArray, warehouseArr]);

    const checkSheetData = () => {
        let data = false;
        sheetData?.forEach(upl => {
            upl?.forEach((val, ind) => {
                if (val && val?.value) data = true;
            });
        });
        return data;
    };

    const fetchItemMasterAll = async (page = 1, perPage = 50) => {
        const filterData = { action: 4, collection: '', filterOperation: 'or', filters: [], limit: perPage, page: page, searchParam: '' };
        try {
            const res = await APIEndpoint.post('master/process', filterData);
            if (res) return res;
        } catch (err) {
            console.error('Error fetching item master:', err);
        }
    };

    async function getItemMasterAll() {
        try {
            const initialRes = await fetchItemMasterAll(1, 1);
            if (initialRes?.count && Array.isArray(initialRes.items) && initialRes.items.length) {
                const fullRes = await fetchItemMasterAll(1, initialRes.count);
                setItemMasterAll([...fullRes.items]);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }

    const fetchStores = async () => {
        try {
            const resp = await APIEndpoint.get('stores');
            if (resp.result.length > 0) setStoreArray(resp.result);
            else console.log('Log: Error while fetching item types API');
        } catch (error) { }
    };

    const fetchWarehouse = async () => {
        try {
            const resp = await APIEndpoint.get(`warehouses`);
            if (resp.success) setWareHouseArr(resp.result);
        } catch (error) {
            console.log("Error fetching warehouses:", error);
        }
    };

    const getWarehouseItems = async (data) => {
        setLoading(true);
        let enumData = {
            warehouseId: Number(data.warehouseId),
            storeId: Number(data.storeId),
            operationDate: formatDateByTimezone((new Date(data.operationDate) ?? new Date()), false)
        };
        try {
            const [resEdit, resEnum] = await Promise.all([
                APIEndpoint.post(`manualRecons/items`, data),
                APIEndpoint.post('stores/pricelist/items/enumerate', enumData),
            ]);
            if (resEdit && resEdit.success) setEditTransferDetails(resEdit);
            if (resEnum && resEnum.success) {
                const warehouseItems = resEnum.items;
                if (!resEdit.items.length) setEditTransferDetails({ ...resEdit, items: resEnum.items });
                const newRows = createEmptySheetRows(null, 10);
                setWarehouseItemsFiltered([...warehouseItems, ...newRows]);
                setWarehouseItemsFull(warehouseItems);
                setLoading(false);
                return warehouseItems;
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const setEditTransferItemsToSheet = (transferDetails, options) => {
        let jsonSpreadsheetData = JSON.stringify(options);
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);
        const items = transferDetails.items;

        if (transferDetails.items && updatedSpreadsheetData.length) {
            items.map((item, i) => {
                if (updatedSpreadsheetData[i]) {
                    updatedSpreadsheetData[i][iIndexes.ITEM_CODE].value = item.itemCode;
                    updatedSpreadsheetData[i][iIndexes.ITEM_NAME].value = item.itemName;
                    updatedSpreadsheetData[i][iIndexes.ITEM_UNIT].value = item.unit;
                    updatedSpreadsheetData[i][iIndexes.ACTUAL_OFFLOAD].value = item.actualOffload;
                    updatedSpreadsheetData[i][iIndexes.DAMAGE].value = item.damage;
                    updatedSpreadsheetData[i][iIndexes.WASTAGE].value = item.wastage;
                    updatedSpreadsheetData[i][iIndexes.EXPIRED].value = item.expired;
                    updatedSpreadsheetData[i][iIndexes.LOST].value = item.lost;
                    updatedSpreadsheetData[i][iIndexes.BACK_TO_WAREHOUSE].value = item.backToWarehouse;
                    updatedSpreadsheetData[i][iIndexes.REMARKS].value = item.remarks;
                }
                return item;
            });
        }

        ReactDOM.flushSync(() => {
            let newRows = createEmptySheetRows(null, 10);
            setSheetData([...updatedSpreadsheetData, ...newRows.slice(sheetData.length)]);
        });
    };

    function syncUpliftDataMaster(updatedData, deletedRowIndex = null) {
        const updatedMap = new Map(
            updatedData.map(row => {
                const itemCode = row.find(c => c.id === "itemCode")?.value;
                return [itemCode, row];
            })
        );

        let merged = reconciliationMaster.map(oldRow => {
            const itemCode = oldRow.find(c => c.id === "itemCode")?.value;
            return updatedMap.has(itemCode) ? [...updatedMap.get(itemCode)] : oldRow;
        });

        if (deletedRowIndex !== null) {
            const deletedItemCode = reconciliationMaster[deletedRowIndex]?.find(c => c.id === "itemCode")?.value;
            merged = merged.filter(row => row.find(c => c.id === "itemCode")?.value !== deletedItemCode);
        }

        setReconciliationMaster(merged);
        return merged;
    }

    const addRowsToSheet = (rowsToAdd = 10) => {
        const newRows = createEmptySheetRows(sheetData.length, rowsToAdd);
        setSheetData([...sheetData, ...newRows]);
        setWarehouseItemsFiltered([...warehouseItemsFiltered, ...newRows]);
    };

    const removeRow = (e) => {
        let jsonSpreadsheetData = JSON.stringify(sheetData);
        let inSheetData = JSON.parse(jsonSpreadsheetData);
        if (selectedCellsArr.length > 1) {
            inSheetData = inSheetData.filter((d, i) => !selectedCellsArr.some(obj => obj.row === i));
            let updatedSheetData = inSheetData.map((row, rowIndex) => {
                return row.map((cell, colIndex) => ({
                    ...cell,
                    className: String(cell.className).includes("errorCellData")
                        ? `cellClass errorCellData cellClass_${rowIndex}_${colIndex}`
                        : `cellClass cellClass_${rowIndex}_${colIndex}`
                }));
            });
            setSheetData([...updatedSheetData]);
            syncUpliftDataMaster(inSheetData, activeCell.row);
            setSelectedCellsArr([]);
            setActiveCell({});
        } else {
            let selectedRowIndex = activeCell.row;
            if (selectedRowIndex || selectedRowIndex === 0) {
                inSheetData.splice(selectedRowIndex, 1);
                let updatedSheetData = inSheetData.map((row, rowIndex) => {
                    return row.map((cell, colIndex) => ({
                        ...cell,
                        className: String(cell.className).includes("errorCellData")
                            ? `cellClass errorCellData cellClass_${rowIndex}_${colIndex}`
                            : `cellClass cellClass_${rowIndex}_${colIndex}`
                    }));
                });
                setSheetData([...updatedSheetData]);
                syncUpliftDataMaster(inSheetData, selectedRowIndex);
                setSelectedCellsArr([]);
                setActiveCell({});
            } else {
                inSheetData.pop();
                syncUpliftDataMaster(inSheetData, null);
                setSheetData([...inSheetData]);
            }
        }
        hidePopupList();
    };

    const showValidationErrors = (e, inSheetData, errorClass = 'cellDataErrorCls') => {
        let haveErrors = false;
        const postItems = [];

        inSheetData.map((cellRow, rowIdx) => {
            let isRowHaveError = false;
            const itemCode = validateCellAndGetData(cellRow[iIndexes.ITEM_CODE], true);
            const itemName = validateCellAndGetData(cellRow[iIndexes.ITEM_NAME], true);
            if (!itemCode || !itemName) return cellRow;

            for (let colIdx = 0; colIdx < Object.keys(iIndexes).length; colIdx++) {
                if (cellRow[colIdx].required === true) {
                    const fieldValue = validateCellAndGetData(cellRow[colIdx], true);
                    if (fieldValue < 0 && (typeof fieldValue === 'string' && !fieldValue.length)) {
                        haveErrors = true;
                        isRowHaveError = true;
                    }
                }
            }

            if (!isRowHaveError) {
                const item = warehouseItemsFiltered.find((row, rowIndex) => row.itemCode === cellRow[iIndexes.ITEM_CODE].value);
                if (item) {
                    postItems.push({
                        itemId: item.itemId,
                        index: rowIdx,
                        itemCode: item.itemCode,
                        itemName: item.itemName,
                        backToWarehouse: parseInt(cellRow[iIndexes.BACK_TO_WAREHOUSE].value) ?? 0,
                        actualOffload: parseInt(cellRow[iIndexes.ACTUAL_OFFLOAD].value),
                        damage: parseInt(cellRow[iIndexes.DAMAGE].value),
                        expired: parseInt(cellRow[iIndexes.EXPIRED].value),
                        lost: parseInt(cellRow[iIndexes.LOST].value),
                        wastage: parseInt(cellRow[iIndexes.WASTAGE].value),
                        unit: item.unit,
                        remarks: cellRow[iIndexes.REMARKS].value || "",
                    });
                }
            }
            return cellRow;
        });

        if (haveErrors) {
            setSpreadsheetErrors([{ message: 'Please fill all required item details.' }]);
        }

        return { sheetData: inSheetData, validRows: postItems, haveErrors };
    };

    const saveSheetData = async (e) => {
        setSpreadsheetErrors([]);
        const settledRecon = syncUpliftDataMaster(sheetData, null);
        let inSheetData = Object.assign([], settledRecon);
        const respArrayData = showValidationErrors(e, inSheetData);

        if (!spreadsheetErrors.length && respArrayData.validRows.length === 0 && !respArrayData.haveErrors) {
            setSpreadsheetErrors([...spreadsheetErrors, { message: 'We did not find anything to save!' }]);
            return false;
        }
        if (respArrayData.haveErrors) return false;
        if (!respArrayData.validRows.length) return false;

        let data = { warehouseId: parseInt(urlParams.wId) };
        if (state.isEditForm === true) {
            data.manualReconId = urlParams.rId;
            data.items = respArrayData.validRows || [];
        } else {
            data.items = respArrayData.validRows || [];
            data.operationDate = urlParams.opDt;
            data.storeId = parseInt(urlParams.sId);
            data.flightDate = urlParams.ftDt;
            data.warehouseId = parseInt(urlParams.wId);
        }

        APIEndpoint.post('manualRecons/save', data)
            .then(apiResp => {
                setSheetData(initialData);
                setErrorDetails([]);
                setSpreadsheetErrors([...spreadsheetErrors, { message: apiResp.msg || apiResp.message || 'Successfully created Reconciliation Report.' }]);
                setTimeout(() => goToModuleHome(), 1500);
            })
            .catch((error) => {
                const apiData = JSON.parse(error.message);
                const { data } = apiData;
                setSpreadsheetErrors([]);
                ReactDOM.flushSync(() => {
                    if (data && data.errors) {
                        const errorMsg = data.errors.message || "Something went wrong, please try again later!";
                        setSpreadsheetErrors([...spreadsheetErrors, { message: errorMsg, error: 1 }]);
                        setErrorDetails(data.errors.errors || []);
                    } else if (data && data?.message) {
                        setSpreadsheetErrors([{ message: data?.message, error: 1 }]);
                    } else {
                        setSpreadsheetErrors([...spreadsheetErrors, { message: 'Something went wrong, please try again later!', error: 1 }]);
                    }
                });
            });

        return false;
    };

    const selectAllCells = (e) => {
        setCount((prev) => prev + 1);
        let updatedSheetData = [];
        if (count % 2 !== 0) {
            updatedSheetData = sheetData.map((row, rowIndex) => row.map((cell, colIndex) => ({
                ...cell,
                className: `selectcell-class cellClass cellClass_${rowIndex}_${colIndex}`
            })));
        } else {
            updatedSheetData = sheetData.map((row, rowIndex) => row.map((cell, colIndex) => ({
                ...cell,
                className: `cellClass cellClass_${rowIndex}_${colIndex}`
            })));
        }
        setSheetData(updatedSheetData);
    };

    const handleActiveCellChange = (activeCell) => {
        calculateBacktoWh();
        setActiveCell({});
        hidePopupList();
        setActiveCell(activeCell);
        if (sheetData[activeCell.row][activeCell.column]) {
            const cellDetailsObj = sheetData[activeCell.row][activeCell.column];
            if (cellDetailsObj.hasOwnProperty('showPopup') && cellDetailsObj.showPopup === true) {
                const sourceElt = document.getElementsByClassName('cellClass_' + activeCell.row + '_' + activeCell.column)[0];
                if (sourceElt) {
                    const eltPosition = sourceElt.getBoundingClientRect();
                    showItemListPopup(eltPosition, activeCell);
                }
            }
        }
    };

    const handleCellBlur = () => { };

    const handleCellKeyDown = (keyboardEvent) => {
        const searchText = keyboardEvent.target.value;
        if (activeCell && Object.keys(activeCell).length > 0) {
            if (sheetData[activeCell.row][activeCell.column].type === 'number' && keyboardEvent.target.value) {
                keyboardEvent.target.value = keyboardEvent.target.value.replace(/[^0-9]$/g, '');
            }
        }
        const searchPattern = new RegExp((searchText || '').replace(/[.*+?^=!:${}()|[\]/\\]/g, '\\$&'), 'gi');
        const filteredList = warehouseItemsFull?.filter(row => row.itemCode.search(searchPattern) !== -1);
        setWarehouseItemsFiltered([...filteredList]);
    };

    const showItemListPopup = (eltPosition, activeCellIn) => {
        if (activeCellIn.column === iIndexes.ITEM_CODE) {
            if (targetEltCodes) {
                targetEltCodes.style.display = 'block';
                targetEltCodes.style.top = (eltPosition.height + eltPosition.top + 2).toFixed() + 'px';
                targetEltCodes.style.left = eltPosition.left.toFixed() + 'px';
            }
        } else if (activeCellIn.column === iIndexes.ITEM_NAME) {
            if (targetEltNames) {
                targetEltNames.style.display = 'block';
                targetEltNames.style.top = (eltPosition.height + eltPosition.top + 2).toFixed() + 'px';
                targetEltNames.style.left = eltPosition.left.toFixed() + 'px';
            }
        }
    };

    const hidePopupList = () => {
        if (targetEltCodes) targetEltCodes.style.display = 'none';
        if (targetEltNames) targetEltNames.style.display = 'none';
        if (targetEltReasonTypes) targetEltReasonTypes.style.display = 'none';
    };

    const onClickPopupListItem = (e, row, type = 'reason') => {
        if (type === 'reason') setReasonField(row);
        else setWarehouseTransferItemToSheet(row);
    };

    const setReasonField = (reason) => {
        if (Object.keys(reason).length === 0) return 0;
        let jsonSpreadsheetData = JSON.stringify(sheetData);
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);
        updatedSpreadsheetData.map((sheetRow, i) => {
            if (i === activeCell.row) sheetRow[iIndexes.ITEM_REASON].value = reason.label;
            return sheetRow;
        });
        ReactDOM.flushSync(() => setSheetData([...updatedSpreadsheetData]));
        setActiveCell({});
        hidePopupList();
    };

    const setWarehouseTransferItemToSheet = (item) => {
        if (Object.keys(item).length === 0) return 0;
        let jsonSpreadsheetData = JSON.stringify(sheetData);
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);
        updatedSpreadsheetData.map((sheetRow, i) => {
            if (i === activeCell.row) {
                sheetRow[iIndexes.ITEM_CODE].value = item.itemCode;
                sheetRow[iIndexes.ITEM_NAME].value = item.itemName;
                sheetRow[iIndexes.ITEM_UNIT].value = item.unit;
                sheetRow[iIndexes.ACTUAL_OFFLOAD].value = item.actualOffload || 0;
                sheetRow[iIndexes.DAMAGE].value = item.damage || 0;
                sheetRow[iIndexes.WASTAGE].value = item.wastage || 0;
                sheetRow[iIndexes.EXPIRED].value = item.expired || 0;
                sheetRow[iIndexes.LOST].value = item.lost || 0;
                sheetRow[iIndexes.BACK_TO_WAREHOUSE].value = item.backToWarehouse || 0;
                sheetRow[iIndexes.REMARKS].value = item.remarks;
            }
            return sheetRow;
        });
        ReactDOM.flushSync(() => {
            let newRows = createEmptySheetRows(null, 10);
            setSheetData([...updatedSpreadsheetData, ...newRows.slice(sheetData.length)]);
        });
        setActiveCell({});
        hidePopupList();
    };


    const sheetDataRef = useRef(sheetData);
    const copiedValuesRef = useRef(copiedValues);
    useEffect(() => { sheetDataRef.current = sheetData; }, [sheetData]);
    useEffect(() => { copiedValuesRef.current = copiedValues; }, [copiedValues]);

  

const handleCellSelect = (selectedCell) => {
    if (selectedCell.length !== 0) {
        setSelectedCellsArr([...selectedCell]);
        selectedCellsRef.current = [...selectedCell];
    }
};
    const isDraggingRef = useRef(false);

useEffect(() => {
    const getCellFromEvent = (e) => {
        const sheetContainer = document.querySelector('.pilferageCreate');
        if (!sheetContainer || !sheetContainer.contains(e.target)) return null;

        let el = e.target;
        while (el && el !== sheetContainer) {
            const classStr = typeof el.className === 'string' ? el.className : '';
            const match = classStr.match(/cellClass_(\d+)_(\d+)/);
            if (match) return { row: parseInt(match[1]), column: parseInt(match[2]) };
            el = el.parentElement;
        }
        return null;
    };

    const getCellFromTd = (e) => {
        const sheetContainer = document.querySelector('.pilferageCreate');
        if (!sheetContainer || !sheetContainer.contains(e.target)) return null;

        let el = e.target;
        while (el && el !== sheetContainer) {
            const classStr = typeof el.className === 'string' ? el.className : '';
            if (classStr.includes('Spreadsheet__active-cell')) {
                return activeCellRef.current && Object.keys(activeCellRef.current).length > 0
                    ? activeCellRef.current
                    : null;
            }
            const match = classStr.match(/cellClass_(\d+)_(\d+)/);
            if (match) return { row: parseInt(match[1]), column: parseInt(match[2]) };
            el = el.parentElement;
        }
        return null;
    };

    const onMouseDown = (e) => {
        isDraggingRef.current = false;
        dragStartCellRef.current = null;
        const cell = getCellFromTd(e);
        dragStartCellRef.current = cell;
    };

    const onMouseMove = (e) => {
        if (e.buttons === 1) isDraggingRef.current = true;
    };

    const onMouseUp = (e) => {

        if (isDraggingRef.current && dragStartCellRef.current) {
            const startCell = dragStartCellRef.current;

            const endCell = getCellFromEvent(e);

            setTimeout(() => {
                const latest = selectedCellsRef.current;
                let cellsToFill = latest;
                if (latest.length <= 1 && endCell && startCell) {
                    const minRow = Math.min(startCell.row, endCell.row);
                    const maxRow = Math.max(startCell.row, endCell.row);
                    const minCol = Math.min(startCell.column, endCell.column);
                    const maxCol = Math.max(startCell.column, endCell.column);
                    cellsToFill = [];
                    for (let r = minRow; r <= maxRow; r++) {
                        for (let c = minCol; c <= maxCol; c++) {
                            cellsToFill.push({ row: r, column: c });
                        }
                    }
                    
                }

                if (cellsToFill.length > 1 && startCell) {
                    const currentSheet = sheetDataRef.current;
                    const sourceCell = currentSheet[startCell.row]?.[startCell.column];
                    const sourceValue = sourceCell?.value;
                    const isReadOnly = sourceCell?.readOnly;


                    if (isReadOnly || sourceValue === '' || sourceValue === null || sourceValue === undefined) {
                        isDraggingRef.current = false;
                        return;
                    }

                    const rows = [...new Set(cellsToFill.map(c => c.row))].sort((a, b) => a - b);
                    const cols = [...new Set(cellsToFill.map(c => c.column))].sort((a, b) => a - b);
                    let updatedData = JSON.parse(JSON.stringify(currentSheet));

rows.forEach((rowIdx) => {
    if (rowIdx === startCell.row) return; 

    if (
        startCell.column === iIndexes.ITEM_CODE ||
        startCell.column === iIndexes.ITEM_NAME
    ) {
     
        const matchedItem = warehouseItemsFullRef.current.find(item =>
            startCell.column === iIndexes.ITEM_CODE
                ? item.itemCode === sourceValue
                : item.itemName === sourceValue
        );

        if (matchedItem) {
            if (!updatedData[rowIdx][iIndexes.ITEM_CODE]?.readOnly)
                updatedData[rowIdx][iIndexes.ITEM_CODE] = { ...updatedData[rowIdx][iIndexes.ITEM_CODE], value: matchedItem.itemCode };
            if (!updatedData[rowIdx][iIndexes.ITEM_NAME]?.readOnly)
                updatedData[rowIdx][iIndexes.ITEM_NAME] = { ...updatedData[rowIdx][iIndexes.ITEM_NAME], value: matchedItem.itemName };
            if (updatedData[rowIdx][iIndexes.ITEM_UNIT])
                updatedData[rowIdx][iIndexes.ITEM_UNIT] = { ...updatedData[rowIdx][iIndexes.ITEM_UNIT], value: matchedItem.unit };
            if (!updatedData[rowIdx][iIndexes.ACTUAL_OFFLOAD]?.readOnly)
                updatedData[rowIdx][iIndexes.ACTUAL_OFFLOAD] = { ...updatedData[rowIdx][iIndexes.ACTUAL_OFFLOAD], value: matchedItem.actualOffload || 0 };
            if (!updatedData[rowIdx][iIndexes.DAMAGE]?.readOnly)
                updatedData[rowIdx][iIndexes.DAMAGE] = { ...updatedData[rowIdx][iIndexes.DAMAGE], value: matchedItem.damage || 0 };
            if (!updatedData[rowIdx][iIndexes.WASTAGE]?.readOnly)
                updatedData[rowIdx][iIndexes.WASTAGE] = { ...updatedData[rowIdx][iIndexes.WASTAGE], value: matchedItem.wastage || 0 };
            if (!updatedData[rowIdx][iIndexes.EXPIRED]?.readOnly)
                updatedData[rowIdx][iIndexes.EXPIRED] = { ...updatedData[rowIdx][iIndexes.EXPIRED], value: matchedItem.expired || 0 };
            if (!updatedData[rowIdx][iIndexes.LOST]?.readOnly)
                updatedData[rowIdx][iIndexes.LOST] = { ...updatedData[rowIdx][iIndexes.LOST], value: matchedItem.lost || 0 };
            if (!updatedData[rowIdx][iIndexes.BACK_TO_WAREHOUSE]?.readOnly)
                updatedData[rowIdx][iIndexes.BACK_TO_WAREHOUSE] = { ...updatedData[rowIdx][iIndexes.BACK_TO_WAREHOUSE], value: matchedItem.backToWarehouse || 0 };
            if (!updatedData[rowIdx][iIndexes.REMARKS]?.readOnly)
                updatedData[rowIdx][iIndexes.REMARKS] = { ...updatedData[rowIdx][iIndexes.REMARKS], value: matchedItem.remarks || '' };
        }
    } else {
        cols.forEach((colIdx) => {
            if (colIdx === startCell.column && updatedData[rowIdx]?.[colIdx] && !updatedData[rowIdx][colIdx].readOnly) {
                updatedData[rowIdx][colIdx] = { ...updatedData[rowIdx][colIdx], value: sourceValue };
            }
        });
    }
});

                    setSheetData([...updatedData]);
                }
            }, 150);
        }

        isDraggingRef.current = false;
        dragStartCellRef.current = null;
    };

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);

    return () => {
        document.removeEventListener('mousedown', onMouseDown);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    };
}, []);

    const onCellCommitHandle = (prevCell, nextCell, coordinates) => { };

    const goToModuleHome = () => navigate('/inventory/reconciliations');

    const handleOnContinue = async () => goToModuleHome();

function calculateBacktoWh() {
    const safeNum = (val) => {
        const n = parseFloat(val);
        return isNaN(n) ? 0 : n;
    };

    const updatedSheetData = sheetData.map((data, rowIndex) => {
        const singleData = data.map((item, index) => {
            if (index === iIndexes.BACK_TO_WAREHOUSE) {
                const itemCode = data[iIndexes.ITEM_CODE]?.value;
                const actualOffloadRaw = data[iIndexes.ACTUAL_OFFLOAD]?.value;
                if (!itemCode || actualOffloadRaw === '' || actualOffloadRaw === null || actualOffloadRaw === undefined) {
                    return { ...item };
                }

                const actualOffload = safeNum(actualOffloadRaw);
                const damage        = safeNum(data[iIndexes.DAMAGE]?.value);
                const wastage       = safeNum(data[iIndexes.WASTAGE]?.value);
                const expired       = safeNum(data[iIndexes.EXPIRED]?.value);
                const lost          = safeNum(data[iIndexes.LOST]?.value);

                const backWh = Math.max(0, actualOffload - (damage + wastage + expired + lost));

                return {
                    ...item,
                    value: backWh,
                    className: `cellClass cellClass_${rowIndex}_${index}`
                };
            }
            return { ...item };
        });
        return [...singleData];
    });

    const sheetDataOld = JSON.stringify(sheetData);
    const sheetDataNew = JSON.stringify(updatedSheetData);
    if (sheetDataOld !== sheetDataNew) setSheetData([...updatedSheetData]);
}

    function handleTypeSelect(selected = null) {
        setFilterItemType((prev) => ({
            all: { ...prev.all, checked: selected === 'all' },
            dutyFree: { ...prev.dutyFree, checked: selected === 'dutyFree' },
            dutyPaid: { ...prev.dutyPaid, checked: selected === 'dutyPaid' },
        }));
    }

    const handleSheetChange = (newData) => {
        setSheetData((prev) => {
            if (JSON.stringify(prev) === JSON.stringify(newData)) return prev;
            return newData;
        });
    };

    return (
        <>
            <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
                {!loading ? <>
                    <div className={"flexRow alignItemsCenter margBot10 justifyContentSpaceBetween"}>
                        <div className="leftBlock alignItemsCenter flexRow">
                            <button onClick={(e) => saveSheetData(e)}
                                className="alignItemsCenter margRight10 add-item-button">
                                <FaSave style={{ marginRight: '5px' }} />{t('buttons.save')}
                            </button>

                            {checkSheetData() ? <>
                                <button onClick={(e) => selectAllCells(e)}
                                    className="alignItemsCenter margRight10 flexRow add-item-button-all">
                                    {count % 2 === 0
                                        ? <BiSolidSelectMultiple style={{ marginRight: '5px' }} />
                                        : <FaRegCheckSquare style={{ marginRight: '5px' }} />}
                                    Select All
                                </button>
                                <button onClick={(e) => removeRow(e)}
                                    className="alignItemsCenter flexRow remove-button">
                                    <RiDeleteBin6Line style={{ marginRight: '5px' }} />{t('buttons.deleteRows')}
                                </button>


                            </> : <></>}
                            &nbsp;

                            <div className='flexRow justifyContentFlexStart width60 scanner-sel' style={{ maxHeight: '2.4rem' }}>
                                <button className={filterItemsType.all.checked ? 'niO4u-ed-checked' : 'niO4u-ed'}
                                    disabled={!filterItemsType.all.count} onClick={() => handleTypeSelect('all')}>
                                    All&nbsp;({filterItemsType.all.count})
                                </button>
                                <button className={filterItemsType.dutyFree.checked ? 'niO4u-ed-checked' : 'niO4u-ed'}
                                    disabled={!filterItemsType.dutyFree.count} onClick={() => handleTypeSelect('dutyFree')}>
                                    Duty Free&nbsp;({filterItemsType.dutyFree.count})
                                </button>
                                <button className={filterItemsType.dutyPaid.checked ? 'niO4u-ed-checked' : 'niO4u-ed'}
                                    disabled={!filterItemsType.dutyPaid.count} onClick={() => handleTypeSelect('dutyPaid')}>
                                    Duty Paid&nbsp;({filterItemsType.dutyPaid.count})
                                </button>
                            </div>
                        </div>

                        {spreadsheetErrors.length >= 1
                            ? <div className={`padding4 margTop9-5 alert alert-${spreadsheetErrors[0].message.includes('fully') ? 'success' : 'danger'}`}>
                                {spreadsheetErrors[0]?.message}
                            </div>
                            : null}

                        <button onClick={goToModuleHome}>
                            <img src={close} alt="close" data-icon="close" />
                        </button>
                    </div>

  

                    <div className="se-titlebar">
                        {<span>
                            {editTransferDetails && editTransferDetails.recon
                                ? `Edit Retrieval - ${editTransferDetails.recon.code}`
                                : reconDetails && reconDetails.warehouse
                                    ? `New Reconciliation - ${reconDetails.warehouse}/${reconDetails.store}/${reconDetails.date}`
                                    : null}
                        </span>}
                    </div>

                    <div className="sheet-container sm-scrollbar pilferageCreate">
                        <ReactSpreadsheet
                            data={sheetData}
                            columnLabels={sheetLabels}
                            darkMode={true}
                            onChange={handleSheetChange}
                            onActivate={handleActiveCellChange}
                            onBlur={handleCellBlur}
                            onKeyDown={handleCellKeyDown}
                            onSelect={handleCellSelect}
                            cellClassName="custom-cell"
                            onCellCommit={onCellCommitHandle}
                        />
                    </div>

                    <div className="flexRow alignItemsCenter margTop8">
                        <button onClick={() => addRowsToSheet()}
                            className="add-item-button" title={t('spreadsheet.addmoreRows')}>
                            {t('buttons.addRows')}
                        </button>
                    </div>

                    {/* Item Code Popup */}
                    <div className="cellSelectionBlockItemCodes sm-scrollbar">
                        {warehouseItemsFiltered.length ? (
                            <ul>
                                {warehouseItemsFiltered.filter(item => !Array.isArray(item)).map((row, i) => (
                                    <li key={i} onClick={(e) => onClickPopupListItem(e, row, 'item')}>{row.itemCode}</li>
                                ))}
                            </ul>
                        ) : null}
                    </div>

                    {/* Item Name Popup */}
                    <div className="cellSelectionBlockItemNames sm-scrollbar">
                        {warehouseItemsFiltered.length ? (
                            <ul>
                                {warehouseItemsFiltered.filter(item => !Array.isArray(item)).map((row, i) => (
                                    <li key={i} onClick={(e) => onClickPopupListItem(e, row, 'item')}>{row.itemName}</li>
                                ))}
                            </ul>
                        ) : null}
                    </div>

                    {/* Reason Types Popup */}
                    <div className="cellSelectionBlockReasonTypes sm-scrollbar">
                        {reasonTypes.length ? (
                            <ul>
                                {reasonTypes.map((row, i) => (
                                    <li key={i} onClick={(e) => onClickPopupListItem(e, row, 'reason')}>{row.label}</li>
                                ))}
                            </ul>
                        ) : null}
                    </div>

                </> : <LoaderPop />}

                {Boolean(state.isInvalidAccess) && (
                    <AlertModal
                        title={'Alert: Invalid Access'}
                        customModalStyle={modelStyle}
                        description={state.message}
                        onContinue={handleOnContinue}
                        onClose={handleOnContinue}
                    />
                )}
            </div>
        </>
    );
}
